<template>
  <div>
    <background-section
      image="sections/testimonials.jpg"
      class="WinnerSection px-4 py-12 text-white pb-l border-dark-red border-t-4"
    >
      <div class="container">
        <fancy-heading
          class="text-center justify-center mb-10"
          title="Големият късметлия"
          subtitle="в бонус играта е:"
          horizontal
          mode="light"
        />
        <div class="flex flex-col items-center">
          <round-avatar
            :src="winner.avatar.full"
            size="xl"
          />
          <div class="text-5xl mt-6 mb-4 text-center">{{ winner.full_name }}</div>
          <div class="text-2xl opacity-75 mb-4">Регистрирал се: {{ winner.registration_date }}</div>
          <div v-if="winner.tickets_count" class="text-2xl opacity-75 mb-10">Закупил {{ winner.tickets_count }} билета за игри</div>
        </div>
      </div>
    </background-section>
    <angle-section
      class="relative text-center py-6"
      color="white"
    >
      <fancy-heading
        class="text-center"
        title="Поощрителни"
        subtitle="награди"
      />
      <div class="px-10">
        <table class="RunnerUpsTable StylizedTable">
          <thead>
            <tr>
              <td>
                Участник
              </td>
              <td>
                Регистриран
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in rest" :key="user.id">
              <td>{{ user.full_name }}</td>
              <td>{{ user.registration_date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </angle-section>
  </div>
</template>

<script>
/**
 * @module RandomRoundWinnerSection
 */
export default {
  name: 'RandomRoundWinnerSection',
  props: {
    winner: {
      type: Object,
      required: true
    },
    rest: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
